/**
 * useToast — auto-dismiss timer hook for toast items.
 *
 * Consumes the toast store and schedules auto-dismissal for each toast
 * based on its duration. Duration of 0 means persistent (no auto-dismiss).
 *
 * @see docs/milestones/M0.6-UI-PRIMITIVES.md §10
 */

import { useEffect } from 'react'
import { useToastStore } from '../toast'

export function useToast() {
  const { toasts, dismiss } = useToastStore()

  // Schedule auto-dismiss for each toast with duration > 0
  useEffect(() => {
    const timers: ReturnType<typeof setTimeout>[] = []

    for (const t of toasts) {
      if (t.duration > 0) {
        const elapsed = Date.now() - t.createdAt
        const remaining = Math.max(t.duration - elapsed, 0)
        timers.push(setTimeout(() => dismiss(t.id), remaining))
      }
    }

    return () => timers.forEach(clearTimeout)
  }, [toasts, dismiss])

  return { toasts, dismiss }
}
